module.exports = __webpack_public_path__ + "media/images/step2-549c35491ac60bef557ea23fef2d3f9d.png";